"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const ModalLink_1 = __importDefault(require("./ModalLink"));
const styles_1 = require("./styles");
const Sentence = ({ addOnType, onTrack, sentence, hasModal, modalContent }) => {
    if (hasModal && modalContent) {
        return (react_1.default.createElement(ModalLink_1.default, { addOnType: addOnType, onTrack: onTrack, sentence: sentence, modalContent: modalContent }));
    }
    return react_1.default.createElement(styles_1.StyledSpan, null, sentence);
};
Sentence.propTypes = {
    addOnType: prop_types_1.default.string.isRequired,
    sentence: prop_types_1.default.string,
    hasModal: prop_types_1.default.bool,
    modalContent: prop_types_1.default.shape({
        title: prop_types_1.default.string,
        body: prop_types_1.default.arrayOf(prop_types_1.default.string)
    }),
    /** signature onTrack(eventName: string, eventData = {[key:string]:string}) */
    onTrack: prop_types_1.default.func
};
Sentence.defaultProps = {
    sentence: '',
    hasModal: false,
    modalContent: null
};
exports.default = Sentence;
//# sourceMappingURL=Sentence.js.map